import React from 'react';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';

export default function FinalCTA() {
  return (
    <section id="book" className="bg-[var(--ob-bg)] px-5 py-24 md:px-8 md:py-32">
      <div className="mx-auto max-w-[1280px]">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-[var(--ob-ink)] px-6 py-20 text-center md:px-16 md:py-28">
            <div className="pointer-events-none absolute -left-16 -top-16 h-64 w-64 rounded-full bg-[var(--ob-accent)]/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-16 -right-16 h-64 w-64 rounded-full bg-[var(--ob-accent)]/20 blur-3xl" />
            <div className="relative">
              <p className="mb-5 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent)]">
                Worst Case = A Free Audit
              </p>
              <h2 className="mx-auto max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white md:text-6xl">
                Ready to add 36%+ to your bottom-line revenue?
              </h2>
              <p className="mx-auto mt-6 max-w-xl text-lg text-white/60">
                We’ll open your Klaviyo account and show you exactly where you’re losing money.
                No strings, no pressure.
              </p>
              <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="https://calendly.com/hello-onbrandadmin/30min" target="_blank" rel="noopener noreferrer"
                  className="ob-btn group inline-flex items-center gap-2 rounded-full bg-[var(--ob-accent)] px-10 py-5 text-lg font-bold text-[var(--ob-dark)] hover:bg-white"
                >
                  Get A Free Strategy Audit
                  <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
                </a>
                <span className="text-sm text-white/50">Takes 30 minutes · No obligation</span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
